var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaskHostfully(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 85,
    viewBox: "0 0 66 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4236_47687)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.9843 38.7169V20.7796L35.5389 -0.312988L33.9395 16.6769L70.9843 38.7169Z",
    fill: "#D8EBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1495 37.2993V64.9999H23.7819V37.2993L6.53125 48.0022V101.36H23.7819V81.6845H47.1495V101.36H64.4002V48.0022L47.1495 37.2993Z",
    fill: "#D6E9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.0625 20.7796L35.5389 -0.312988V17.6321L-0.0625 38.7169V20.7796Z",
    fill: "#D6E9FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4236_47687"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 71,
    height: 101,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaskHostfully);
export default __webpack_public_path__ + "static/media/mask-hostfully.e1c2329802f2f84688caff670726d07e.svg";
export { ForwardRef as ReactComponent };